<div class="rre-management">
	<div class="header-label">
		<h2>RRE Management</h2>
	</div>

	<div class="top-controls-row">
		<mat-form-field appearance="outline" class="search-bar" subscriptSizing="dynamic">
			<mat-label>Search RRE</mat-label>
			<input matInput [value]="searchTerm" (input)="onSearch(($any($event.target)).value)"
				placeholder="Type to search..." autocomplete="off" />
			<button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
				<mat-icon>close</mat-icon>
			</button>
			<mat-icon matPrefix>search</mat-icon>
		</mat-form-field>

		<button mat-flat-button color="primary" class="top-controls-action-btn" (click)="addRRE()">Add RRE</button>
	</div>

	<div *ngIf="errorMessage" class="api-error-banner">
		{{ errorMessage }}
	</div>

	<div class="table-loader" *ngIf="loading">
		<mat-spinner [diameter]="50"></mat-spinner>
	</div>

	<div class="table-wrapper" [class.loading]="loading">
		<table mat-table [dataSource]="dataSource" matSort [matSortActive]="sortBy" [matSortDirection]="sortDir"
			class="full-width rre-management-table">
			<ng-container matColumnDef="rre">
				<th mat-header-cell *matHeaderCellDef mat-sort-header="rre">RRE</th>
				<td mat-cell *matCellDef="let row">{{ row.Rre }}</td>
			</ng-container>

			<ng-container matColumnDef="rreName">
				<th mat-header-cell *matHeaderCellDef mat-sort-header="rreName">RRE Name</th>
				<td mat-cell *matCellDef="let row">{{ row.RreName || '-' }}</td>
			</ng-container>

			<ng-container matColumnDef="reportingGroup">
				<th mat-header-cell *matHeaderCellDef mat-sort-header="reportingGroup">Reporting Group</th>
				<td mat-cell *matCellDef="let row">{{ row.ReportingGroup || '-' }}</td>
			</ng-container>

			<ng-container matColumnDef="queryReportingOn">
				<th mat-header-cell *matHeaderCellDef mat-sort-header="queryReportingOn">Query Reporting</th>
				<td mat-cell *matCellDef="let row">
					<mat-icon class="status-icon" [class.active]="row.QueryReportingOn" [attr.aria-label]="row.QueryReportingOn ? 'Enabled' : 'Disabled'">
						{{ row.QueryReportingOn ? 'check_circle' : 'cancel' }}
					</mat-icon>
					<span class="sr-only">{{ row.QueryReportingOn ? 'Enabled' : 'Disabled' }}</span>
				</td>
			</ng-container>

			<ng-container matColumnDef="claimReportingOn">
				<th mat-header-cell *matHeaderCellDef mat-sort-header="claimReportingOn">Claim Reporting</th>
				<td mat-cell *matCellDef="let row">
					<mat-icon class="status-icon" [class.active]="row.ClaimReportingOn" [attr.aria-label]="row.ClaimReportingOn ? 'Enabled' : 'Disabled'">
						{{ row.ClaimReportingOn ? 'check_circle' : 'cancel' }}
					</mat-icon>
					<span class="sr-only">{{ row.ClaimReportingOn ? 'Enabled' : 'Disabled' }}</span>
				</td>
			</ng-container>

			<ng-container matColumnDef="isocpAccountDesigneeOnly">
				<th mat-header-cell *matHeaderCellDef mat-sort-header="isocpAccountDesigneeOnly">ISOCP Designee Only
				</th>
				<td mat-cell *matCellDef="let row">
					<mat-icon class="status-icon" [class.active]="row.IsocpAccountDesigneeOnly" [attr.aria-label]="row.IsocpAccountDesigneeOnly ? 'Enabled' : 'Disabled'">
						{{ row.IsocpAccountDesigneeOnly ? 'check_circle' : 'cancel' }}
					</mat-icon>
					<span class="sr-only">{{ row.IsocpAccountDesigneeOnly ? 'Enabled' : 'Disabled' }}</span>
				</td>
			</ng-container>

			<ng-container matColumnDef="comment">
				<th mat-header-cell *matHeaderCellDef mat-sort-header="comment">Comment</th>
				<td mat-cell *matCellDef="let row">{{ row.Comment || '-' }}</td>
			</ng-container>

			<ng-container matColumnDef="lastUpdated">
				<th mat-header-cell *matHeaderCellDef mat-sort-header="lastUpdated">Last Updated</th>
				<td mat-cell *matCellDef="let row">{{ row.LastUpdated ? (row.LastUpdated | date: 'mediumDate') : '-' }}
				</td>
			</ng-container>

			<ng-container matColumnDef="lastUpdatedBy">
				<th mat-header-cell *matHeaderCellDef mat-sort-header="lastUpdatedBy">Last Updated By</th>
				<td mat-cell *matCellDef="let row">{{ row.LastUpdatedBy || '-' }}</td>
			</ng-container>

			<ng-container matColumnDef="actions">
				<th mat-header-cell *matHeaderCellDef class="no-header"></th>
				<td mat-cell *matCellDef="let row" class="actions-cell">
					<button mat-icon-button type="button" matTooltip="Edit" class="table-action-btn table-action-edit"
						(click)="onEdit(row)" aria-label="Edit RRE">
						<mat-icon>edit</mat-icon>
					</button>
				</td>
			</ng-container>

			<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
			<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
		</table>

		<div *ngIf="!loading && dataSource.data.length === 0" class="no-results-message">
			No RRE records found
		</div>
	</div>

	<mat-paginator [length]="totalCount" [pageIndex]="pageIndex" [pageSize]="pageSize" [pageSizeOptions]="pageSizes"
		(page)="onPageChange($event)" showFirstLastButtons></mat-paginator>
</div>